import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2333_11605",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 25,
		children: /* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2333_11605)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.327 9.55775V8.05775H20.5V9.55775H7.327ZM7.327 13.25V11.75H20.5V13.25H7.327ZM7.327 16.9423V15.4423H20.5V16.9423H7.327ZM4.30775 9.6155C4.07892 9.6155 3.88708 9.53717 3.73225 9.3805C3.57742 9.22383 3.5 9.02967 3.5 8.798C3.5 8.572 3.57742 8.3825 3.73225 8.2295C3.88708 8.0765 4.07892 8 4.30775 8C4.53658 8 4.72842 8.0765 4.88325 8.2295C5.03808 8.3825 5.1155 8.572 5.1155 8.798C5.1155 9.02967 5.03808 9.22383 4.88325 9.3805C4.72842 9.53717 4.53658 9.6155 4.30775 9.6155ZM4.30775 13.298C4.07892 13.298 3.88708 13.2215 3.73225 13.0685C3.57742 12.9157 3.5 12.7262 3.5 12.5C3.5 12.2615 3.57742 12.0657 3.73225 11.9125C3.88708 11.7593 4.07892 11.6827 4.30775 11.6827C4.53658 11.6827 4.72842 11.7593 4.88325 11.9125C5.03808 12.0657 5.1155 12.2615 5.1155 12.5C5.1155 12.7262 5.03808 12.9157 4.88325 13.0685C4.72842 13.2215 4.53658 13.298 4.30775 13.298ZM4.30775 17C4.07892 17 3.88708 16.9217 3.73225 16.765C3.57742 16.6083 3.5 16.4142 3.5 16.1827C3.5 15.9566 3.57742 15.767 3.73225 15.614C3.88708 15.461 4.07892 15.3845 4.30775 15.3845C4.53658 15.3845 4.72842 15.461 4.88325 15.614C5.03808 15.767 5.1155 15.9566 5.1155 16.1827C5.1155 16.4142 5.03808 16.6083 4.88325 16.765C4.72842 16.9217 4.53658 17 4.30775 17Z",
			fill: "#118AB2"
		})
	})]
});
export default SvgListActive;
